import React from "react"

const ReceptionIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_12988_10986)">
        <path
          d="M5 8.5H11"
          stroke="#4B504F"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3 6V4.5C3 3.96957 3.21071 3.46086 3.58579 3.08579C3.96086 2.71071 4.46957 2.5 5 2.5H11C11.5304 2.5 12.0391 2.71071 12.4142 3.08579C12.7893 3.46086 13 3.96957 13 4.5V6"
          stroke="#4B504F"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 10.5V8C5 7.60444 4.8827 7.21776 4.66294 6.88886C4.44318 6.55996 4.13082 6.30362 3.76537 6.15224C3.39992 6.00087 2.99778 5.96126 2.60982 6.03843C2.22186 6.1156 1.86549 6.30608 1.58579 6.58579C1.30608 6.86549 1.1156 7.22186 1.03843 7.60982C0.96126 7.99778 1.00087 8.39992 1.15224 8.76537C1.30362 9.13082 1.55996 9.44318 1.88886 9.66294C2.21776 9.8827 2.60444 10 3 10V12.5C3 12.6326 3.05268 12.7598 3.14645 12.8536C3.24022 12.9473 3.36739 13 3.5 13H12.5C12.6326 13 12.7598 12.9473 12.8536 12.8536C12.9473 12.7598 13 12.6326 13 12.5V10C13.3956 10 13.7822 9.8827 14.1111 9.66294C14.44 9.44318 14.6964 9.13082 14.8478 8.76537C14.9991 8.39992 15.0387 7.99778 14.9616 7.60982C14.8844 7.22186 14.6939 6.86549 14.4142 6.58579C14.1345 6.30608 13.7781 6.1156 13.3902 6.03843C13.0022 5.96126 12.6001 6.00087 12.2346 6.15224C11.8692 6.30362 11.5568 6.55996 11.3371 6.88886C11.1173 7.21776 11 7.60444 11 8V10.5"
          stroke="#4B504F"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_12988_10986">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ReceptionIcon
